import { LiveStreamAnalytics } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/metadata/live-stream-analytics';
import { NAMES as LIVESTREAM_ACTIONS } from '../../actions/live-streams';

const defaultState = new LiveStreamAnalytics({
  projectId: '',
  streamId: '',
  stats: [],
});

let lastState = defaultState;

export const liveStreamAnalytics = (
  state: LiveStreamAnalytics = defaultState,
  action,
) => {
  switch (action.type) {
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_ANALYTICS_SUCCESS:
      lastState = action.payload.rawResponse;
      return action.payload.rawResponse;
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_ANALYTICS_START:
      return lastState;
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_ANALYTICS_ERROR:
      return defaultState;

    default:
      return state;
  }
};
